import { Observable } from 'rxjs';
import { PaymentsRepository } from '../domain/payments/repository';

import HttpClient from '../utils/http-client';
import { ApiResponse } from '../domain/common/api-response';

export class PaymentsRepositoryImplementation extends PaymentsRepository {
    getPayMethods(uid: string, cid: string | null): Observable<ApiResponse<any>> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.get('/paymethods/public');
    }

    create(data: any): Observable<ApiResponse<any>> {
        const httpClient = new HttpClient("", "");
        return httpClient.post('/sells', data);
    }

    cancel(bill_id: string): Observable<ApiResponse<any>> {
        const httpClient = new HttpClient("", "");
        return httpClient.put(`/sells/${bill_id}/cancel`, {});
    }

    sell_print(prefix: string, number: string): Observable<ApiResponse<any>> {
        const httpClient = new HttpClient("", "");
        return httpClient.get(`/sells/${prefix}/${number}`);
    }

    show_pdf(cufe: string): Observable<ApiResponse<any>> {
        const httpClient = new HttpClient("", "");
        return httpClient.get(`/sells/invoice/pdf/${cufe}`);
    }

    sync_sell(bill_id: number | string): Observable<ApiResponse<any>> {
        const httpClient = new HttpClient("", "");
        return httpClient.post(`/sells/${bill_id}/sync`, {});
    }
}
